<div class="container-fluid px-2 px-sm-4 py-3" style="padding-bottom:calc(48px + env(safe-area-inset-bottom, 0px) + 16px);">

  <h1 class="text-center fw-bold mb-3">{{ title }}</h1>

  <!-- Mobile tab navigation -->
  <nav class="d-md-none mb-3">
    <div class="d-flex nav-pills-mobile" style="background:var(--bs-tertiary-bg);border-radius:10px;padding:3px;gap:3px;">
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='energie'"
              (click)="setTab('energie')">⚡ Energie</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='klima'"
              (click)="setTab('klima')">🌡 Klima</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='muell'"
              (click)="setTab('muell')">🗑️ Müll</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='netzwerk'"
              (click)="setTab('netzwerk')">🌐 Netz</button>
      <button class="nav-tab-btn flex-fill py-2 rounded-3 border-0 small fw-semibold"
              [class.active]="activeTab==='statistik'"
              (click)="setTab('statistik')">📊 Statistik</button>
    </div>
  </nav>

  <!-- ═══ ENERGIE ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'energie'">
    <app-energie
      [solar]="solar"
      [solarHistory]="solarHistory"
      [solarFlash]="solarFlash"
      [liveDotOn]="liveDotOn"
      [solarUpdatedAt]="solarUpdatedAt"
      [nowTick]="nowTick"
      [todayStat]="todayStat"
      [darkMode]="darkMode"
      (openSolarChart)="openSolarChart()">
    </app-energie>
  </div>

  <!-- ═══ KLIMA ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'klima'">
    <app-klima
      [thermometers]="thermometers"
      [thermometerHistory]="thermometerHistory"
      [thermoFlash]="thermoFlash"
      [liveDotOn]="liveDotOn"
      [thermoUpdatedAt]="thermoUpdatedAt"
      [nowTick]="nowTick"
      [darkMode]="darkMode">
    </app-klima>
  </div>

  <!-- ═══ MÜLL ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'muell'">
    <app-muell
      [nextPickupsByType]="nextPickupsByType"
      [wastePickups]="wastePickups"
      [loading]="!wasteLoaded"
      [darkMode]="darkMode">
    </app-muell>
  </div>

  <!-- ═══ STATISTIK ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'statistik'">
    <app-statistik
      [stats]="stats"
      [loading]="!statsLoaded"
      [darkMode]="darkMode">
    </app-statistik>
  </div>

  <!-- ═══ NETZWERK ═══ -->
  <div *ngIf="!isMobileView || activeTab === 'netzwerk'">
    <app-netzwerk
      [unifi]="unifi"
      [unifiTimedOut]="unifiTimedOut"
      [darkMode]="darkMode">
    </app-netzwerk>
  </div>

</div>

<!-- Footer -->
<footer class="fixed-bottom bg-body-tertiary border-top d-flex align-items-center px-3 flex-nowrap gap-2"
        style="height:48px;z-index:1030;">
  <span class="text-muted small me-auto text-nowrap overflow-hidden" style="min-width:0;">
    © {{ currentYear }}
    <span class="d-none d-sm-inline">blonkel.com</span>
    &nbsp;|&nbsp;<code style="cursor:pointer;" (click)="openChangelog()" title="Changelog">{{ shortHash(frontendCommit) }}</code>
    <span class="d-none d-sm-inline">&nbsp;|&nbsp;<code style="cursor:pointer;" (click)="openChangelog()" title="Changelog">{{ shortHash(vs.backendCommit) || '…' }}</code></span>
  </span>
  <span class="text-muted small text-nowrap flex-shrink-0" [title]="'OFFENE_WEBSOCKET' | translate">
    {{ vs.connectedClients }} 👥
  </span>
  <!-- Dark mode toggle -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2 ms-1" (click)="toggleDarkMode()"
          [title]="(darkMode ? 'LIGHT_MODE' : 'DARK_MODE') | translate" style="line-height:1;">
    <svg *ngIf="darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/>
    </svg>
    <svg *ngIf="!darkMode" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/>
    </svg>
  </button>
  <!-- Language switcher -->
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0 px-2" (click)="openLangPicker()" [title]="'SPRACHE' | translate">
    <span class="emoji-flag">{{ currentLangFlag }}</span>
  </button>
  <button class="btn btn-sm btn-outline-secondary flex-shrink-0" (click)="toggleAdmin()">
    ⚙️ Admin
  </button>
</footer>

<!-- Admin Overlay -->
<div *ngIf="adminOpen"
     style="position:fixed;inset:0;z-index:1050;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeAdmin()">

  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:calc(100vw - 32px);height:calc(100vh - 32px);border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">⚙️ Admin</span>
      <button *ngIf="logAuthenticated" class="btn btn-sm btn-outline-danger" (click)="adminLogout()">Logout</button>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeAdmin()">✕</button>
    </div>

    <!-- Not authenticated: password prompt only, no navigation hints -->
    <div *ngIf="!logAuthenticated"
         class="flex-grow-1 d-flex align-items-center justify-content-center p-4">
      <div style="max-width:320px;width:100%;">
        <div *ngIf="logAuthError" class="alert alert-danger py-2 small mb-3">{{ 'FALSCHES_PASSWORT' | translate }}</div>
        <label class="form-label fw-semibold">{{ 'PASSWORT' | translate }}</label>
        <div class="input-group">
          <input type="password" class="form-control" [(ngModel)]="logPassword"
                 [placeholder]="'LOGS_PASSWORT' | translate"
                 (keydown.enter)="submitLogPassword()">
          <button class="btn btn-primary" (click)="submitLogPassword()">{{ 'OEFFNEN' | translate }}</button>
        </div>
      </div>
    </div>

    <!-- Authenticated: full navigation + content -->
    <ng-container *ngIf="logAuthenticated">

      <!-- Mobile tab strip -->
      <div class="d-flex d-md-none border-bottom flex-shrink-0" style="overflow-x:auto;">
        <button class="btn btn-sm px-3 py-2 rounded-0 border-0 flex-shrink-0"
                [class.fw-semibold]="adminSection === 'logs'"
                [style.border-bottom]="adminSection === 'logs' ? '2px solid var(--bs-primary)' : '2px solid transparent'"
                (click)="setAdminSection('logs')">
          🗒 {{ 'LOGS' | translate }}
        </button>
        <button class="btn btn-sm px-3 py-2 rounded-0 border-0 flex-shrink-0"
                [class.fw-semibold]="adminSection === 'clients'"
                [style.border-bottom]="adminSection === 'clients' ? '2px solid var(--bs-primary)' : '2px solid transparent'"
                (click)="setAdminSection('clients')">
          🔌 Clients
        </button>
      </div>

      <!-- Body: sidebar + content -->
      <div class="d-flex flex-row flex-grow-1 overflow-hidden">

        <!-- Desktop sidebar -->
        <nav class="d-none d-md-flex flex-column border-end flex-shrink-0 py-2" style="width:160px;">
          <button class="btn btn-sm text-start px-3 py-2 rounded-0 border-0"
                  [class.fw-semibold]="adminSection === 'logs'"
                  [class.bg-primary-subtle]="adminSection === 'logs'"
                  (click)="setAdminSection('logs')">
            🗒 {{ 'LOGS' | translate }}
          </button>
          <button class="btn btn-sm text-start px-3 py-2 rounded-0 border-0"
                  [class.fw-semibold]="adminSection === 'clients'"
                  [class.bg-primary-subtle]="adminSection === 'clients'"
                  (click)="setAdminSection('clients')">
            🔌 Clients
          </button>
        </nav>

        <!-- Section content -->
        <div class="flex-grow-1 overflow-hidden d-flex flex-column" [ngSwitch]="adminSection">

          <!-- ── Logs ── -->
          <ng-container *ngSwitchCase="'logs'">

            <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
              <div class="btn-group btn-group-sm me-auto" role="group">
                <button type="button" class="btn"
                        [class.btn-secondary]="logLevel === 'all'"
                        [class.btn-outline-secondary]="logLevel !== 'all'"
                        (click)="setLogLevel('all')">{{ 'ALLE' | translate }}</button>
                <button type="button" class="btn"
                        [class.btn-secondary]="logLevel === 'low'"
                        [class.btn-outline-secondary]="logLevel !== 'low'"
                        (click)="setLogLevel('low')">Low</button>
                <button type="button" class="btn"
                        [class.btn-warning]="logLevel === 'medium'"
                        [class.btn-outline-warning]="logLevel !== 'medium'"
                        (click)="setLogLevel('medium')">Medium</button>
                <button type="button" class="btn"
                        [class.btn-danger]="logLevel === 'high'"
                        [class.btn-outline-danger]="logLevel !== 'high'"
                        (click)="setLogLevel('high')">High</button>
              </div>
              <button class="btn btn-sm btn-outline-secondary" (click)="fetchLogs()" [title]="'AKTUALISIEREN' | translate">↻</button>
            </div>

            <div class="flex-grow-1 overflow-hidden p-2">
              <div *ngIf="copiedCell" class="text-muted small mb-1">{{ 'KOPIERT' | translate }}</div>
              <div *ngIf="logs.length === 0" class="text-muted small text-center py-3">{{ 'KEINE_EINTRAEGE' | translate }}</div>
              <ag-grid-angular
                *ngIf="logs.length > 0"
                [class]="darkMode ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'"
                style="height:100%;"
                [rowData]="logs"
                [columnDefs]="colDefs"
                [gridOptions]="gridOptions"
                [tooltipShowDelay]="200">
              </ag-grid-angular>
            </div>

          </ng-container>

          <!-- ── Clients ── -->
          <ng-container *ngSwitchCase="'clients'">

            <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
              <span class="text-muted small me-auto">{{ clients.length }} verbunden</span>
              <button class="btn btn-sm btn-outline-secondary" (click)="fetchClients()" title="Aktualisieren">↻</button>
            </div>

            <div class="flex-grow-1 overflow-auto p-3">
              <div *ngIf="clients.length === 0" class="text-muted small text-center py-3">Keine Verbindungen</div>
              <div *ngFor="let c of clients" class="card mb-2">
                <div class="card-body p-2" style="font-size:.8rem;">
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <span class="badge bg-success">🔌 verbunden</span>
                    <span class="fw-semibold">{{ c.ip }}</span>
                    <span class="text-muted ms-auto" style="font-size:.72rem;">seit {{ c.connectedAt | date:'dd.MM.yy HH:mm:ss' }}</span>
                  </div>
                  <div class="text-muted text-truncate" style="font-size:.72rem;" [title]="c.userAgent">{{ c.userAgent || '–' }}</div>
                  <div class="text-muted" style="font-size:.68rem; font-family: monospace;">
                    <span *ngIf="c.xRealIp">X-Real-IP: {{ c.xRealIp }}<br></span>
                    <span *ngIf="c.xForwardedFor">X-Forwarded-For: {{ c.xForwardedFor }}<br></span>
                    <span>remote: {{ c.remoteAddr }}</span>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>

        </div>
      </div>

    </ng-container>
  </div>
</div>

<!-- Language Picker Overlay -->
<div *ngIf="langPickerOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeLangPicker()">

  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(94vw,560px);max-height:80vh;border-radius:12px;overflow:hidden;"
       (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">🌐 {{ 'SPRACHE' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeLangPicker()">✕</button>
    </div>

    <!-- Search -->
    <div class="px-3 py-2 border-bottom flex-shrink-0">
      <input class="form-control form-control-sm" type="search"
             [placeholder]="'SUCHEN' | translate" [(ngModel)]="langSearch" autofocus>
    </div>

    <!-- Language grid -->
    <div class="overflow-auto p-2" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:6px;">
      <button *ngFor="let l of filteredLanguages"
              class="btn btn-sm text-start d-flex align-items-center gap-2 px-2 py-2"
              [class.btn-primary]="translate.currentLang === l.code"
              [class.btn-secondary]="translate.currentLang !== l.code && supportedLangs.has(l.code)"
              [class.btn-outline-secondary]="!supportedLangs.has(l.code)"
              [style.opacity]="supportedLangs.has(l.code) ? '1' : '0.4'"
              [disabled]="!supportedLangs.has(l.code)"
              (click)="selectLang(l.code)">
        <span class="emoji-flag" style="font-size:1.3rem;line-height:1;">{{ l.flag }}</span>
        <span class="min-w-0">
          <div class="fw-semibold small text-truncate" style="line-height:1.2;">{{ l.native }}</div>
          <div class="text-muted" style="font-size:.7rem;line-height:1.2;">{{ l.name }}</div>
        </span>
      </button>
    </div>

  </div>
</div>

<!-- 24h Solar Chart Overlay -->
<div *ngIf="solarChartOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.6);"
     (click)="closeSolarChart()">
  <div class="bg-body shadow-lg"
       style="width:min(92vw,1600px);max-height:92vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold">📈 24h</span>
      <div class="d-flex flex-wrap gap-2 ms-auto" style="font-size:.75rem;">
        <span><span style="color:#f59e0b;">■</span> ☀️ {{ 'CHART_ERTRAG' | translate }}</span>
        <span><span style="color:#22c55e;">■</span> 🔋 {{ 'AKKU' | translate }}</span>
        <span><span style="color:#ef4444;">■</span> 🔌 {{ 'CHART_NETZ' | translate }}</span>
        <span><span style="color:#3b82f6;">■</span> ⚡ {{ 'VERBRAUCH' | translate }}</span>
      </div>
      <button class="btn btn-sm btn-outline-secondary ms-2" (click)="closeSolarChart()">✕</button>
    </div>
    <div class="p-2 p-sm-3">
      <app-solar-chart
        [history]="solarHistory"
        [darkMode]="darkMode"
        [labelPv]="'CHART_ERTRAG' | translate"
        [labelBattery]="'AKKU' | translate"
        [labelGrid]="'CHART_NETZ' | translate"
        [labelTotal]="'VERBRAUCH' | translate">
      </app-solar-chart>
      <div class="text-muted text-center mt-1" style="font-size:.65rem;">{{ solarHistory.length }} {{ 'MESSPUNKTE' | translate }}</div>
    </div>
  </div>
</div>

<!-- Initial connecting overlay (before first WS connection) -->
<div *ngIf="!vs.wsConnectedOnce && !newVersionVisible"
     style="position:fixed;inset:0;background:var(--bs-body-bg);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="text-center">
    <div class="spinner-border text-primary mx-auto mb-3" role="status"></div>
    <p class="text-muted small mb-0">{{ 'VERBINDUNG_WIRD_HERGESTELLT' | translate }}</p>
  </div>
</div>

<!-- Disconnect overlay (hidden when version update overlay takes over) -->
<div *ngIf="vs.wsConnectedOnce && !vs.connected && !newVersionVisible"
     style="position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:1060;display:flex;align-items:center;justify-content:center;">
  <div class="card text-center shadow-lg p-4" style="max-width:340px;">
    <div class="spinner-border text-danger mx-auto mb-3" role="status"></div>
    <h5 class="card-title">{{ 'VERBINDUNG_UNTERBROCHEN' | translate }}</h5>
    <p class="card-text text-muted small">{{ 'VERBINDUNG_VERLOREN' | translate }}</p>
  </div>
</div>

<!-- Changelog Overlay -->
<div *ngIf="changelogOpen"
     style="position:fixed;inset:0;z-index:1055;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);"
     (click)="closeChangelog()">
  <div class="bg-body shadow-lg d-flex flex-column"
       style="width:min(96vw,640px);max-height:80vh;border-radius:8px;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="d-flex align-items-center gap-2 px-3 py-2 border-bottom flex-shrink-0">
      <span class="fw-semibold me-auto">{{ 'CHANGELOG' | translate }}</span>
      <button class="btn btn-sm btn-outline-secondary" (click)="closeChangelog()">✕</button>
    </div>
    <div class="overflow-auto p-3">
      <div *ngIf="changelog.length === 0" class="text-muted small text-center py-3">
        <div class="spinner-border spinner-border-sm me-2"></div>{{ 'LADE' | translate }}
      </div>
      <div *ngFor="let c of changelog" class="d-flex gap-3 py-2 border-bottom">
        <div class="flex-shrink-0 text-muted small" style="width:80px;padding-top:2px;">
          <div>{{ c.date }}</div>
          <code style="font-size:.7rem;">{{ c.hash | slice:0:7 }}</code>
        </div>
        <div class="min-w-0">
          <div class="small fw-semibold text-break">{{ c.subject }}</div>
          <div class="text-muted" style="font-size:.7rem;">{{ c.author }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Version update overlay -->
<div *ngIf="newVersionVisible"
     style="position:fixed;inset:0;background:rgba(0,0,0,0.65);z-index:1070;display:flex;align-items:center;justify-content:center;">
  <div class="card text-center shadow-lg p-4" style="max-width:360px;width:100%;">
    <div class="fs-1 mb-2">🚀</div>
    <h5 class="card-title">{{ 'NEUE_VERSION' | translate }}</h5>
    <p class="card-text text-muted small mb-3">{{ 'NEUE_VERSION_HINWEIS' | translate }}</p>

    <!-- Prefetch status -->
    <div class="mb-3" style="min-height:2.5rem;">

      <!-- Loading: show progress bar + fraction -->
      <ng-container *ngIf="prefetchStatus === 'loading'">
        <div class="d-flex align-items-center justify-content-center gap-2 text-muted small mb-1">
          <div class="spinner-border spinner-border-sm flex-shrink-0" style="width:.85rem;height:.85rem;border-width:2px;"></div>
          <span *ngIf="prefetchTotal === 0">Verbinde mit Server…</span>
          <span *ngIf="prefetchTotal > 0">{{ prefetchLoaded }}&thinsp;/&thinsp;{{ prefetchTotal }} Dateien geladen</span>
        </div>
        <div class="progress mx-auto" style="height:3px;max-width:200px;">
          <div class="progress-bar bg-primary"
               [style.width.%]="prefetchTotal > 0 ? prefetchLoaded / prefetchTotal * 100 : 0"
               style="transition:width .2s ease;"></div>
        </div>
      </ng-container>

      <!-- Prerendering -->
      <ng-container *ngIf="prefetchStatus === 'prerendering'">
        <div class="d-flex align-items-center justify-content-center gap-2 text-muted small mb-1">
          <div class="spinner-border spinner-border-sm flex-shrink-0" style="width:.85rem;height:.85rem;border-width:2px;"></div>
          <span>Vorrendering &amp; Verbindung…</span>
        </div>
        <div class="progress mx-auto" style="height:3px;max-width:200px;">
          <div class="progress-bar bg-info progress-bar-striped progress-bar-animated" style="width:100%;"></div>
        </div>
      </ng-container>

      <!-- Ready -->
      <div *ngIf="prefetchStatus === 'ready'" class="text-success small fw-semibold">
        ✓ Update gecacht — bereit zum Laden
      </div>

      <!-- Failed -->
      <div *ngIf="prefetchStatus === 'failed'" class="text-warning small">
        ⚠ Vorab-Download fehlgeschlagen — Update läuft trotzdem
      </div>

    </div>

    <!-- Internet status -->
    <div class="d-flex align-items-center justify-content-center gap-1 mb-3 small"
         [class.text-success]="isOnline" [class.text-danger]="!isOnline">
      <span style="font-size:.55rem;">●</span>
      <span>{{ isOnline ? 'Internet verbunden' : 'Kein Internet' }}</span>
    </div>

    <button class="btn w-100"
            [class.btn-primary]="prefetchStatus === 'ready'"
            [class.btn-outline-secondary]="prefetchStatus === 'loading' || prefetchStatus === 'prerendering'"
            [class.btn-warning]="prefetchStatus === 'failed'"
            [disabled]="prefetchStatus === 'loading' || prefetchStatus === 'prerendering'"
            (click)="applyUpdate()">
      <!-- Step 1: downloading assets -->
      <ng-container *ngIf="prefetchStatus === 'loading'">
        <span class="spinner-border spinner-border-sm me-1" style="width:.7rem;height:.7rem;border-width:2px;vertical-align:middle;"></span>
        Herunterladen… {{ prefetchLoaded }}&thinsp;/&thinsp;{{ prefetchTotal }}
      </ng-container>
      <!-- Step 2: prerendering -->
      <ng-container *ngIf="prefetchStatus === 'prerendering'">
        <span class="spinner-border spinner-border-sm me-1" style="width:.7rem;height:.7rem;border-width:2px;vertical-align:middle;"></span>
        Vorrendering…
      </ng-container>
      <!-- Step 3: ready — countdown running -->
      <ng-container *ngIf="prefetchStatus === 'ready' || prefetchStatus === 'failed'">
        {{ 'NEUE_VERSION_LADEN' | translate }} ({{ versionCountdown > 0 ? versionCountdown : 0 }})
      </ng-container>
    </button>
  </div>
</div>
